import { type FC } from 'react'
import { Dropdown } from 'shared/ui'
import type { GroupInbox } from 'entities/Inbox/model/GroupInbox'
import { useConversationMenuContext } from 'pages/conversations/ui/ConversationMenu/context'
import {
  actionTeamsFavorite,
  menuTeamsFavorite,
} from 'pages/conversations/ui/ConversationMenu/ui/ConversationMenuInboxes/Dropdown/Actions/TeamsFavorite'
import {
  actionUngroup,
  menuUngroup,
} from 'pages/conversations/ui/ConversationMenu/ui/ConversationMenuInboxes/Dropdown/Actions/Ungroup'
import {
  actionRename,
  menuRename,
} from 'pages/conversations/ui/ConversationMenu/ui/ConversationMenuInboxes/Dropdown/Actions/Rename'

type IDropdownGroupInboxProps = {
  inbox: GroupInbox
}

export const DropdownGroupInbox: FC<IDropdownGroupInboxProps> = ({ inbox }) => {
  const store = useConversationMenuContext()

  return (
    <Dropdown
      ariaLabel={'DropdownGroupInbox'}
      icon={'moreHorizontal'}
      placement={'bottom-end'}
      tooltipProps={{
        disableInteractive: true,
        label: 'Show actions',
        placement: 'top-end',
      }}
      items={[menuTeamsFavorite(inbox), menuUngroup(), menuRename()]}
      onChange={(item) => {
        actionTeamsFavorite({ inbox, item }, store)
        actionUngroup({ inbox, item }, store)
        actionRename({ inbox, item }, store)
      }}
      width={inbox.is_favorite ? 128 : 122}
    />
  )
}
